/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import omit from 'object.omit';
import VDialog from '@cloud-sn/v-dialog';
import { buildComponentName } from '../utils';
var __vue_script__ = {
  name: buildComponentName('Modal'),
  components: {
    VDialog: VDialog
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-modal'
    },
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '520px'
    },
    okType: {
      type: String,
      default: 'primary'
    },
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    zIndex: [Number, String],
    dialogStyle: Object,
    dialogClass: [String, Array, Object],
    wrapClass: [String, Array, Object],
    wrapStyle: Object,
    maskTransitionName: {
      type: String,
      default: 'fade'
    },
    transitionName: {
      type: String,
      default: 'zoom'
    },
    getContainer: {
      type: Function,
      default: undefined
    },
    bodyStyle: Object,
    maskStyle: Object,
    mask: {
      type: Boolean,
      default: true
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    okCancel: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: 'light'
    },
    control: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bindProps: function bindProps() {
      return omit(this.$props, ['confirmLoading', 'okType', 'okText', 'cancelText']);
    }
  },
  methods: {
    close: function close() {
      this.$emit('input', false);
    },
    onOk: function onOk(e) {
      var control = this.control,
          close = this.close;

      if (!control) {
        close();
      }

      this.$emit('ok', e);
    },
    onCancel: function onCancel(e) {
      var control = this.control,
          close = this.close;

      if (!control) {
        close();
      }

      this.$emit('cancel', e);
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-dialog', _vm._g(_vm._b({
    class: _vm.prefixCls + "-" + _vm.theme,
    on: {
      "close": _vm.onCancel
    }
  }, 'v-dialog', _vm.bindProps, false), _vm.$listeners), [_vm.title || _vm.$slots.title ? _c('template', {
    slot: "title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2) : _vm._e(), _vm._t("default"), !_vm.hideFooter ? _c('template', {
    slot: "footer"
  }, [_vm._t("footer", [_vm.okCancel ? _c('button', {
    staticClass: "ux-btn",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.cancelText) + " ")]) : _vm._e(), _c('button', {
    staticClass: "ux-btn",
    class: "ux-btn-" + _vm.okType,
    on: {
      "click": _vm.onOk
    }
  }, [_vm._v(" " + _vm._s(_vm.okText) + " ")])])], 2) : _vm._e()], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "modal.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;